import { AbstractControl } from '@angular/forms';

export class HorasUtil {

  /**
   * Normaliza una hora a HH:MM sin cambiar el significado de los datos.
   * Se admite 24:00 porque el informe lo utiliza como límite del día.
   */
  static normalizar(valor: any): string {
    if (valor === null || valor === undefined) { return ''; }

    let texto = String(valor).trim().replace(/\s+/g, '');
    if (texto === '') { return ''; }

    texto = texto.replace(/[.,;]/g, ':');
    let horas: string;
    let minutos: string;
    let partes: string[];

    if (/^\d{1,2}:\d{1,2}$/.test(texto)) {
      partes = texto.split(':');
      horas = partes[0];
      minutos = partes[1];
    } else if (/^\d{3,4}$/.test(texto)) {
      horas = texto.length === 3 ? texto.substr(0, 1) : texto.substr(0, 2);
      minutos = texto.substr(texto.length - 2);
    } else {
      return null;
    }

    const h = Number(horas);
    const m = Number(minutos);
    if (!isFinite(h) || !isFinite(m) || h < 0 || h > 24 || m < 0 || m > 59) {
      return null;
    }
    if (h === 24 && m !== 0) { return null; }

    return ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2);
  }

  static valida(valor: any): boolean {
    return HorasUtil.normalizar(valor) !== null;
  }

  static validador(control: AbstractControl): { [key: string]: any } {
    return HorasUtil.valida(control.value) ? null : { horaInvalida: true };
  }
}



// WEBPACK FOOTER //
// ./src/providers/horas/horas.ts